import { t } from '../i18n/index.js';

/* An open tab or the installed app can keep running for days. When a newer version of Plume
   is online, say so once and offer a reload, the way Slack or Linear do. */
let shown=false,last=0;
const mine=()=>{const s=document.querySelector('script[type="module"][src*="/assets/"]');return s?new URL(s.getAttribute('src'),location.href).pathname:null};
async function check(){
  if(shown||document.hidden||navigator.onLine===false)return;
  const cur=mine();if(!cur)return;
  if(Date.now()-last<60000)return;last=Date.now();
  try{
    const r=await fetch('/?v='+Date.now(),{cache:'no-store'});if(!r.ok)return;
    const m=(await r.text()).match(/<script[^>]*type="module"[^>]*src="([^"]*\/assets\/[^"]+\.js)"/);
    if(m&&new URL(m[1],location.href).pathname!==cur)show();
  }catch(e){}
}
function show(){
  shown=true;
  const d=document.createElement('div');d.className='updatebar';d.setAttribute('role','status');
  d.innerHTML=`<span>${t('upd.ready')}</span><button type="button" class="btn small primary">${t('upd.reload')}</button>`;
  d.querySelector('button').onclick=()=>location.reload();
  document.body.appendChild(d);
}
export function initUpdateCheck(){
  if(import.meta.env.DEV||!mine())return;      // dev server and tests have no built bundle to compare
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)check()});
  window.addEventListener('focus',check);
  setInterval(check,10*60*1000);
  setTimeout(check,20000);
}
